<template>
  <div class="content-wrapper">
   <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Billing Payment/History</h1>
          </div> -->
          <div class="col-sm-6">
           <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'dashboard'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">My Offers</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-9">
            <router-link class="back-link" :to="{ name: 'dashboard' }"><i class="fas fa-chevron-left"></i>  Back</router-link>
         <div class="offers text-center">
        <iframe
            src="https://api-ads.dotlines.com.sg/dae/show-ads?publisher_id=83b264002deed4e4b4de41d38a3413bfb96800c626871b081d2c1074b1e6c285&type=image&size=leaderboard&district=Carnival%20UK%20District%20One&upazila=Carnival%20UK%20Upz%20One&zone=Carnival%20UK%20Zone%201&callback=0"
            scrolling="no" marginwidth="0" marginheight="0" style="border: 0px none; vertical-align: middle;"
            aria-label="Advertisement" tabindex="0" width="728" height="90" frameborder="0"></iframe>
        <iframe
            src="https://api-ads.dotlines.com.sg/dae/show-ads?publisher_id=83b264002deed4e4b4de41d38a3413bfb96800c626871b081d2c1074b1e6c285&type=image&size=leaderboard&district=Carnival%20UK%20District%20One&upazila=Carnival%20UK%20Upz%20One&zone=Carnival%20UK%20Zone%202&callback=0"
            scrolling="no" marginwidth="0" marginheight="0" style="border: 0px none; vertical-align: middle;"
            aria-label="Advertisement" tabindex="0" width="728" height="90" frameborder="0"></iframe>
        <iframe
            src="https://api-ads.dotlines.com.sg/dae/show-ads?publisher_id=83b264002deed4e4b4de41d38a3413bfb96800c626871b081d2c1074b1e6c285&type=image&size=leaderboard&district=Carnival%20UK%20District%20One&upazila=Carnival%20UK%20Upz%20Two&zone=Carnival%20UK%20Zone%203&callback=0"
            scrolling="no" marginwidth="0" marginheight="0" style="border: 0px none; vertical-align: middle;"
            aria-label="Advertisement" tabindex="0" width="728" height="90" frameborder="0"></iframe>
        <iframe
            src="https://api-ads.dotlines.com.sg/dae/show-ads?publisher_id=83b264002deed4e4b4de41d38a3413bfb96800c626871b081d2c1074b1e6c285&type=image&size=leaderboard&district=Carnival%20UK%20District%20One&upazila=Carnival%20UK%20Upz%20Two&zone=Carnival%20UK%20Zone%204&callback=0"
            scrolling="no" marginwidth="0" marginheight="0" style="border: 0px none; vertical-align: middle;"
            aria-label="Advertisement" tabindex="0" width="728" height="90" frameborder="0"></iframe>
        </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AccountView",
  metaInfo: {
    title: "My Information | Dotlines",
  },
  components: {
    //
  },

  data: () => ({
    params: {},
    value: {},
    is_loading: false,
  }),

  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    let _this = this;
    _this.param = _this.$route.params;
    _this.getAccountDetail(_this.param.id);
  },

  computed: {
    ...mapGetters(["profile"]),
  },

  methods: {
    ...mapActions(["FETCH_PROFILE"]),

    getAccountDetail: function (id) {
      let api_url = "/get-account-info";
      let _this = this;
      _this.is_loading = true;
      axios
        .get(api_url)
        .then((response) => {
          console.log("response.data::", response.data);
          _this.value = response.data;
          _this.is_loading = false;
        })
        .catch((error) => {
          console.log("error " + error);
          _this.is_loading = false;
        });
    },
  },
};
</script>

